import "magnific-popup";

if ($("#activities").length) {
  $("#activities")
    .find(".popup")
    .magnificPopup({
      type: "iframe",
      closeOnBgClick: true,
      closeBtnInside: true,
      callbacks: {
        parseAjax: function (mfpResponse) {
          // mfpResponse.data = $(mfpResponse.data).find('#rental.preview');
        },
        ajaxContentAdded: function () {
          // initBackground();
        },
      },
    });
}
